import { message as $message } from 'antd'
import { getLocalTerminalDomain } from '@/utils/jump'
import { getLoginCode } from '@/services/login'
import { getToken } from '@/utils/token'
import { getStore } from '@/utils/dva'

// 双奇电商城集合页内跳转到渠道侧
export const onSqGoChannel = async params => {
    const { pathname, isOpen } = params || {}
    if (!pathname) {
        return
    }

    const url = `${getLocalTerminalDomain(PROJECT_CONFIG.channelTerminalName)}${pathname}`

    if (!getToken()) {
        window.open(url)
        return
    }
    try {
        const { success, data, message } = await getLoginCode()
        if (success) {
            const newUrl = encodeURIComponent(url)

            const route = `${getLocalTerminalDomain(
                PROJECT_CONFIG.accountTerminalName,
            )}/jumpPage/index?simple_token=${data}&redirect=${newUrl}`

            if (isOpen) {
                window.open(route)
                return
            }
            location.href = route
        } else {
            $message.error(message)
        }
    } catch (error) {
        console.error('catchError', error)
    }
}

// 查看市场
export const onScanSqmall = async ({ domain }) => {
    const { config } = getStore().getState().sqmallAndOp

    const mallDomain = domain || config?.domain?.mallDomain

    const url = `${mallDomain}/sqmall/collection`

    if (window.TERMINANAME_IS_SQMALL) {
        location.href = url
        return
    }
    if (!getToken()) {
        window.open(url)
        return
    }
    try {
        const { success, data, message } = await getLoginCode()
        if (success) {
            const newUrl = encodeURIComponent(url)

            const path = `${mallDomain}/jumpPage/index?simple_token=${data}&redirect=${newUrl}`

            window.open(path)
        } else {
            $message.error(message)
        }
    } catch (error) {
        console.error('catchError', error)
    }
}
